import { render, staticRenderFns } from "./alarmTrigger.vue?vue&type=template&id=1c86d6b2&scoped=true&"
import script from "./alarmTrigger.vue?vue&type=script&lang=js&"
export * from "./alarmTrigger.vue?vue&type=script&lang=js&"
import style0 from "./alarmTrigger.vue?vue&type=style&index=0&id=1c86d6b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86d6b2",
  null
  
)

export default component.exports